<div class="w-full flex justify-center">
  <div class="{{ height }} {{ width }}">
    <img class="h-full w-full animate-spin" style="transform-origin: 50% 50%;"
         src="/assets/images/icon/fitmed-icon-coloured.svg">
  </div>
</div>
